import React from 'react'
import { unitVariations } from '../../../data/unitVariations';

const CentralInventoryConsumptionTable = ({
    consumptionData,
    convertToNewBaseQuantity
}) => {
    return (
        <div className="grid grid-cols-2 gap-6 mt-4 text-sm max-w-4xl">
            {/* LEFT TABLE */}
            <div className="border p-2">
                <div className="rounded-md border overflow-x-auto max-h-[400px] tiny-scrollbar">
                    <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100 sticky top-0 z-10">
                            <tr>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    Item Name
                                </th>

                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    Produced
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-100">
                            {consumptionData?.processed_items?.length > 0 ? (
                                consumptionData.processed_items.map((item, index) => (

                                    <tr
                                        key={index}
                                        className="hover:bg-gray-50"
                                    >
                                        <td className="px-3 py-2">
                                            {item.item_name}
                                        </td>

                                        <td className="px-3 py-2">
                                            {item.quantity_sold}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={3}
                                        className="px-3 py-4 text-gray-500"
                                    >
                                        No data available
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>

                <div className="mt-2 p-2 space-y-2">
                    <div className="grid grid-cols-2 gap-2 items-center">
                        <label className="font-medium">
                            Total Items :
                        </label>

                        <input
                            readOnly
                            value={
                                consumptionData?.summary
                                    ?.total_production_recipes || 0
                            }
                            className="border p-1 rounded w-full font-semibold text-center bg-white"
                        />

                        <label className="font-medium">
                            Total Quantity Produced :
                        </label>

                        <input
                            readOnly
                            value={
                                consumptionData?.summary
                                    ?.total_quantity_sold || 0
                            }
                            className="border p-1 rounded w-full font-semibold text-center bg-white"
                        />

                        <label className="font-medium">
                            Raw Materials Consumed :
                        </label>

                        <input
                            readOnly
                            value={
                                consumptionData?.summary
                                    ?.total_raw_materials_consumed || 0
                            }
                            className="border p-1 rounded w-full font-semibold text-center bg-white"
                        />
                    </div>
                </div>
            </div>

            {/* RIGHT TABLE */}
            <div className="border p-2">
                <div className="rounded-md border overflow-x-auto max-h-[400px] tiny-scrollbar">
                    <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                        <thead className="bg-gray-100 sticky top-0 z-10">
                            <tr>
                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    Item
                                </th>

                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    Amount
                                </th>

                                <th className="px-1 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">
                                    UOM
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-100">
                            {consumptionData?.consumption_details &&
                                Object.keys(consumptionData.consumption_details).length > 0 ? (
                                Object.entries(consumptionData.consumption_details)
                                    .sort(([a], [b]) =>
                                        a.localeCompare(b)
                                    )
                                    .map(([itemName, details], index) => {

                                        const convertedQty =
                                            convertToNewBaseQuantity({
                                                quantity:
                                                    details?.total_quantity,

                                                unit: details?.unitdefinition.unit,

                                                fromUom:
                                                    details?.uom,

                                                toUom:
                                                    details?.new_uom,

                                                kgVars:
                                                    unitVariations.kg,

                                                gVars:
                                                    unitVariations.gram,

                                                lVars:
                                                    unitVariations.liter,

                                                mlVars:
                                                    unitVariations.milliliter
                                            });

                                        const safeQty =
                                            isNaN(convertedQty)
                                                ? 0
                                                : convertedQty;

                                        return (
                                            <tr
                                                key={index}
                                                className={
                                                    details?.is_standard_uom === false
                                                        ? "bg-amber-50 text-amber-600"
                                                        : ""
                                                }
                                            >
                                                <td className="px-3 py-2">
                                                    {itemName}
                                                </td>

                                                <td className="px-3 py-2">
                                                    {safeQty}
                                                </td>

                                                <td className="px-3 py-2">
                                                    {
                                                        details?.new_uom ||
                                                        details?.uom ||
                                                        "-"
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })
                            ) : (
                                <tr>
                                    <td
                                        colSpan={3}
                                        className="px-3 py-4 text-gray-500"
                                    >
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default CentralInventoryConsumptionTable